interface CompareRow {
  key: string;
  left?: string;
  right?: string;
  status: string;
}

interface CompareTableProps {
  rows: CompareRow[];
}

export function CompareTable({ rows }: CompareTableProps) {
  if (!rows.length) {
    return <p>No comparable specs available yet.</p>;
  }
  return (
    <table className="compare-table">
      <thead>
        <tr>
          <th>Spec</th>
          <th>Left</th>
          <th>Right</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.key} className={row.status === "different" ? "diff" : undefined}>
            <th>{row.key}</th>
            <td>{row.left ?? "–"}</td>
            <td>{row.right ?? "–"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
